import { Module }       from 'vuex';
import { RootState }    from '@/store/store.types';
import state            from '@/views/rate-checker-configuration/rate-checker-table/store/rate-checker-table.state.store';
import actions          from '@/views/rate-checker-configuration/rate-checker-table/store/rate-checker-table.actions.store';
import mutations        from '@/views/rate-checker-configuration/rate-checker-table/store/rate-checker-table.mutations.store';
import { RateCheckerTableState } from '@/views/rate-checker-configuration/rate-checker-table/rate-checker-table.types';

const store: Module<RateCheckerTableState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
};

export default store;
